const VehicleConfiguratorActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    SHOW_ACTION_V2: 'SHOW_ACTION_V2',
    SHOW_VEHICLE_NOT_PROVIDED_LAYER: 'SHOW_VEHICLE_NOT_PROVIDED_LAYER',
    HIDE_VEHICLE_NOT_PROVIDED_LAYER: 'HIDE_VEHICLE_NOT_PROVIDED_LAYER',
    SET_VEHICLE_NOT_PROVIDED_COMMENT: 'SET_VEHICLE_NOT_PROVIDED_COMMENT',
    HIDE_ACTION: 'HIDE_ACTION',
    SHOW_MAIN_LAYER: 'SHOW_MAIN_LAYER',
    SET_MAKE: 'SET_MAKE',
    SET_MODEL: 'SET_MODEL',
    SET_ENGINE: 'SET_ENGINE',
    SET_YEAR: 'SET_YEAR',
    SET_SERIES_CHASSIS: 'SET_SERIES_CHASSIS',
    SET_DETAILS: 'SET_DETAILS',
    SET_TYRES: 'SET_TYRES',
    SET_VALUES: 'SET_VALUES',
    RESET_VALUES: 'RESET_VALUES',
    SET_LOADING_CHECK: 'SET_LOADING_CHECK',
    SET_LOADING_CHECK_DONE: 'SET_LOADING_CHECK_DONE',
    SET_OUT_OF_STOCK: 'SET_OUT_OF_STOCK',
    SET_IN_STOCK: 'SET_IN_STOCK',
    SET_POSTCODE: 'SET_POSTCODE',
    SHOW_POSTCODE_INVALID: 'SHOW_POSTCODE_INVALID',
    HIDE_POSTCODE_INVALID: 'HIDE_POSTCODE_INVALID',
    SET_TYRE_OPTIONS: 'SET_TYRE_OPTIONS',
    SET_POSTCODE_SUGGESTION: 'SET_POSTCODE_SUGGESTION',
    SHOW_INFO_LAYER: 'SHOW_INFO_LAYER',
    HIDE_INFO_LAYER: 'HIDE_INFO_LAYER',
};

export { VehicleConfiguratorActions };
